import { MaskedInputProps } from 'react-text-mask';
import React from 'react';
import { FieldType } from '@models/field-builder/field-type';
import { LabelPosition } from '@models/field-builder/label-position';

export interface FieldOption {
    key: string;
    label: string;
    disabled?: boolean;
}

export interface Field {
    type: FieldType;
    id: string;
    className?: string;
    setValueMethod?: (value) => void;
    value?: any;
    label?: string | React.ReactNode;
    labelPosition?: LabelPosition;
    placeHolder?: string;
    width?: number;
    fullWidth?: boolean;
    onChange?: (event) => void;
    options?: FieldOption[];
    defaultOption?: string;
    hidden?: boolean;
    disabled?: boolean;
    checked?: boolean;
    helperText?: string | React.ReactNode;
    maxWidth?: number;
    dropdownHeight?: string;
    maskOptions?: Partial<MaskedInputProps>;
    innerFields?: Field[][];
    hasError?: boolean;
    style?: React.CSSProperties;
}

export const FieldDefinition = {
    defaultWidth: 300
};



// WEBPACK FOOTER //
// ./src/models/field-builder/field.ts